import {useQuery} from "@tanstack/react-query";
import UserService from "@lib/User/UserService";
import {qk} from "@queries/keys";
import {FORM_TYPE} from "@lib/Form/FormModels";

export function useUser(params?: { withToken?: boolean, token?: string | null; }) {

    const token = params?.token;
    const withToken = params?.withToken ?? false;

    return useQuery({
        queryKey: qk.jnextUser(),
        enabled: !withToken || (withToken && !!token),
        queryFn: () => UserService.getUser(token),
        staleTime: 60_000,
        retry: false,
    });
}

export const useUserForm = (params: { formType: FORM_TYPE }) => {

    const {formType} = params;

    return useQuery({
        queryKey: qk.formConfig(formType),
        queryFn: () => UserService.getForm(formType),
        staleTime: 60_000,
        retry: false,
    });

}